import Vue from "vue";
import { Component } from "vue-property-decorator";
import Navigation from "@/components/navigation/navigation.vue";
import Footer from "@/components/footer/footer.vue";
import SVGIcons from "@/assets/SVGIcons.vue";

@Component({ name: "App", components: { Navigation, Footer, SVGIcons } })
export default class App extends Vue {
}